import { useState } from 'react';

import useCreateAudienceFeedback from 'services/general/useCreateAudienceFeedback';
import type { OverlayQuestionProps } from './types';
import { showOverlaySubmitErrorToast } from './toast';

import { ButtonSizes, Typography } from '@repo/ui';
import { Button, ButtonColors, ButtonVariants } from 'components';
import { NpsScale } from '../../NpsScale/NpsScale';

import styles from '../AudienceFeedbackOverlay.module.css';

const TITLE = 'How helpful was the video explanation?';

const VideoHelpfulQuestion = ({
  kitId,
  feedbackType,
  extraInfo,
  onDone,
}: OverlayQuestionProps) => {
  const [score, setScore] = useState<number | null>(null);
  const createFeedback = useCreateAudienceFeedback();
  const isSubmitting = createFeedback.isPending;
  const isSubmitDisabled = score == null;

  const onSubmit = async () => {
    if (isSubmitting || score == null) return;

    try {
      await createFeedback.mutateAsync({
        kitId,
        question: TITLE,
        answer: String(score),
        type: feedbackType,
        extraInfo,
        component: 'VideoHelpfulQuestion',
      });
    } catch (err) {
      console.error(
        'Failed to submit AudienceFeedback/VideoHelpfulQuestion',
        err,
      );
      showOverlaySubmitErrorToast();
    }

    onDone();
  };

  return (
    <div className={styles.content}>
      <Typography variant='body-m' className={styles.primaryText}>
        {TITLE}
      </Typography>

      <Typography variant='label' className={styles.secondaryText}>
        {'(1 = not helpful, 10 = extremely helpful)'}
      </Typography>

      <div className={styles.inputRow}>
        <NpsScale label={TITLE} value={score} onChange={setScore} />
      </div>

      <div className={styles.actionsRow}>
        <Button
          label='Next'
          onClick={onSubmit}
          disabled={isSubmitDisabled || isSubmitting}
          loading={isSubmitting}
          variant={ButtonVariants.SOLID}
          color={ButtonColors.GREEN}
          size={ButtonSizes.S}
        />
      </div>
    </div>
  );
};

export default VideoHelpfulQuestion;
